export default "__VITE_ASSET__DhZ2kygx__"